import dayjs, { Dayjs } from 'dayjs';
import { Translation } from 'hooks/useTranslation/useTranslation';
import { VisitorGroupAutocompleteOption } from 'v2/utils/visitorGroupAutocomplete';

export const handleNameInputValidation = (
  translation: Translation,
  setNameInputValidation: (value: string | undefined) => void,
  nameInputValue?: string
) => {
  if (nameInputValue === '') setNameInputValidation(translation.name_cannot_be_empty);
  else setNameInputValidation(undefined);
};

export const handleVisitorGroupInputValidation = (
  translation: Translation,
  setVisitorGroupInputValidation: (value: string | undefined) => void,
  visitorGroupInputValue?: VisitorGroupAutocompleteOption | null,
  isInstallerOrAdministratorRoleEnabled: boolean = false
) => {
  visitorGroupInputValue === null && !isInstallerOrAdministratorRoleEnabled
    ? setVisitorGroupInputValidation(translation.group_cannot_be_empty)
    : setVisitorGroupInputValidation(undefined);
};

export const handleExpirationDateInputValidation = (
  translation: Translation,
  setExpirationDateInputValidation: (value: string | undefined) => void,
  expirationDateTo: dayjs.Dayjs | null,
  isExpirationDateEnabled?: boolean
) => {
  if (isExpirationDateEnabled && expirationDateTo?.isBefore(dayjs()))
    setExpirationDateInputValidation(translation.expiration_date_past_error);
  else setExpirationDateInputValidation(undefined);
};

export const handleExpirationDateInputValue = (
  setExpirationDateInputValue: React.Dispatch<React.SetStateAction<dayjs.Dayjs | undefined>>,
  expirationDateTo?: Dayjs | undefined
) => {
  if (expirationDateTo) setExpirationDateInputValue(expirationDateTo);
  else setExpirationDateInputValue(undefined);
};

export const handleSwitchIsExpirationDateOnChange = (
  setIsExpirationDateEnabled: (value: React.SetStateAction<boolean | undefined>) => void,
  setExpirationDateInputValue: (value: React.SetStateAction<dayjs.Dayjs | null>) => void,
  expirationDateTo: dayjs.Dayjs | null,
  isExpirationDateEnabled?: boolean
) => {
  setIsExpirationDateEnabled(!isExpirationDateEnabled);
  if (expirationDateTo === undefined) {
    setExpirationDateInputValue(dayjs().add(1, 'day'));
  }
  setExpirationDateInputValue(!isExpirationDateEnabled && expirationDateTo ? expirationDateTo : null);
};

export const handleSwitchIsAdministratorRoleEnableOnChange = (
  setIsAdministratorRoleEnabled: (value: React.SetStateAction<boolean>) => void,
  isAdministratorRoleEnabled?: boolean
) => {
  setIsAdministratorRoleEnabled(!isAdministratorRoleEnabled);
};
